import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        licences: '=',
        licencePoint: '=',
        userId: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2 ng-if="!vm.form.model.id">{{ 'licence.Add licence points' | translate }}</h2>
            <h2 ng-if="vm.form.model.id">{{ 'licence.Edit licence points' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <div class="form">
                    <form-row
                        error="vm.form.errors.isFulfillingPrecondition"
                        ng-if="vm.showFulfillingToggle"
                    >
                        <label class="label">{{ 'licence.Fulfills precondition' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input
                                    type="checkbox"
                                    ng-model="vm.form.model.isFulfillingPrecondition"
                                    ng-change="vm.toggleIsFulfillingPrecondition()"
                                >
                                <span></span>
                            </label>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <div class="alert alert-warn" ng-if="!vm.form.model.id && vm.form.model.isPastPeriodAllowed">
                        {{ 'licence.past_periods_warning' | translate }}
                    </div>
                    <form-row
                        error="vm.form.errors.isPastPeriodAllowed"
                        ng-if="!vm.form.model.id && vm.PrivilegeService.canManagePastLicencePeriodPoints()">
                            <label class="label">{{ 'licence.Add points to past periods' | translate }}</label>
                            <div class="items">
                                <label class="switch01">
                                    <input type="checkbox" ng-model="vm.form.model.isPastPeriodAllowed" ng-change="vm.reloadLicences()">
                                    <span></span>
                                </label>
                                <form-row-error></form-row-error>
                            </div>
                    </form-row>
                    <form-row error="vm.form.errors.title">
                        <label class="label">{{ 'licence.Title' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.title" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.points">
                        <label class="label">{{ 'licence.Points' | translate }} *</label>
                        <div class="items">
                            <input ng-keyup="vm.isFloat()" ng-model="vm.form.model.points" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.obtainmentDate">
                        <label class="label">
                            {{ 'licence.Points obtainment date' | translate }} *
                            <small>{{ 'licence.Date on which the entered points were obtained (not entered to Coursy)' | translate }}</small>
                        </label>
                        <div class="items">
                            <datepicker-api ng-model="vm.form.model.obtainmentDate"></datepicker-api>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <!-- CREATE use multiple and update use single at the moment -->
                    <modals-user-employee-licence-points-single-form-rows
                        ng-if="vm.licencePoint"
                        form="vm.form"
                        user-id="vm.userId"
                        licences="vm.licences"
                        periods="vm.periods"
                    />
                    <modals-user-employee-licence-points-multiple-form-rows
                        ng-if="!vm.licencePoint"
                        form="vm.form"
                        user-id="vm.userId"
                        licences="vm.licences"
                        show-fulfilling-toggle="vm.showFulfillingToggle"
                    />
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary" ng-if="!vm.form.saving">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li class="primary" ng-if="vm.licencePoint.id">
                    <button class="btn negative" type="button" ng-click="vm.delete()">{{ 'general.Delete' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($rootScope, $translate, lodash, FormFactory, UserResource, LicenceResource,
                 LicencePeriodResource, MomentService, ModalService, PrivilegeService, NumberService) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.UserResource = UserResource;
        this.LicenceResource = LicenceResource;
        this.LicencePeriodResource = LicencePeriodResource;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.NumberService = NumberService;
    }

    $onInit () {
        const { UserResource, FormFactory } = this;
        if (this.licencePoint) {
            this.form = FormFactory.create(new UserResource(this.licencePoint), m => m.$updateLicencePoint({ id: m.id }));
            this.form.model.isPastPeriodAllowed = true;
        }
        else {
            this.form = FormFactory.create(new UserResource, m => m.$assignLicencePoint({ id: this.userId }));
        }
        this.showFulfillingToggle = false;

        if (this.licencePoint && this.PrivilegeService.canManagePreconditionsOnLicencePoints()) {
            const pointLicence = this.licences.filter((licence) => this.licencePoint.licenceId === licence.id);
            if (pointLicence[0].licencePreconditions.length) {
                this.showFulfillingToggle = true;
            }
        }
    }

    toggleIsFulfillingPrecondition () {
        this.form.model.addPointsToMultipleLicences = false;
        if (this.form.model.hasOwnProperty('userLicencePoints')) {
            // keep first element only
            this.form.model.userLicencePoints.length = 1;
        }
    }

    isFloat () {
        this.form.errors.points = this.$translate.instant('licencePoint.Points must be number with up to two decimal places');
        if (this.NumberService.isFloat(this.form.model.points)) {
            delete this.form.errors.points;
        }
    }

    reloadLicences () {
        this.LicenceResource.query({
            userId: this.userId,
            isValid: true,
            isPastPeriodAllowed: this.form.model.isPastPeriodAllowed,
            pageSize: 0,
            expand: 'licencePreconditions'
        }).$promise.then((licences) => {
            this.licences = licences;
            this.$rootScope.$emit('reload.licencePeriods');
        });
    }

    save () {
        if ((!this.licencePoint || !this.licencePoint.isFulfillingPrecondition)
            && this.form.model.isFulfillingPrecondition) {
            const message = this.$translate.instant('licencePoint.Entered points will be used to fulfill the precondition on the licence. Are you sure you wish to enter the points?');
            this.ModalService.confirm(message, 'medium').then(() => this.doSave());
        }
        else {
            this.doSave();
        }
    }

    doSave () {
        if (!this.licencePoint) {
            this.UserResource.assignLicencePoint({ id: this.userId }, this.form.model).$promise.then(() => {
                this.uibModalInstance.close();
            }).catch((errors) => {
                const filteredErrors = this.filterUserLicencePaths(errors);
                this.form.parseErrors(filteredErrors);
            });
        }
        else {
            this.form.save()
                .then(() => this.uibModalInstance.close());
        }
    }

    filterUserLicencePaths (errors) {
        const errorsPathToRemove = ['title', 'points'];
        return {
            data: errors.data.map((error) => {
                if (errorsPathToRemove.includes(error.field)) {
                    delete error.path;
                }
                return error;
            })
        };
    }

    delete () {
        const selectedPeriod = this.lodash.find(this.periods, period => {
            return period.id === this.licencePoint.licencePeriodId;
        });
        const message = this.MomentService.isPassedDate(selectedPeriod.enteringDate) ?
            this.$translate.instant('licencePoint.Are you sure you wish to remove past period licence points?') :
            this.$translate.instant('licencePoint.Are you sure you wish to remove selected licence points?')
        ;
        return this.ModalService.delete(message)
            .then(() => {
                this.UserResource.deleteLicencePoint({ id: this.licencePoint.id }).$promise
                    .then(() => {
                        this.uibModalInstance.close();
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/licencePoints/index.js